import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/documents')({
  component: DocumentsLayoutComponent,
})

function DocumentsLayoutComponent() {
  return <Outlet />
}
